/**
 * Routes that send an already-authenticated business user straight to /dashboard.
 *
 * Single source of truth - pages must NOT add their own ad-hoc "if logged in, go
 * to dashboard" guard; add the path here instead. Only routes an already-logged-in
 * user has nothing to do on belong here: landing pages, and sign-up (a logged-in
 * user should never register again).
 *
 * Deliberately excluded:
 * - /login - has its own guard (an `intent=upgrade` deep-link goes to /upgrade).
 * - /reset-password, /setup-account - recovery/invite links must render for a
 *   logged-in user (a stale session must not bounce them off the flow).
 * - /admin-login - redirects to /admin, not /dashboard.
 */
export const DASHBOARD_REDIRECT_ROUTES: readonly string[] = ['/', '/register']
